import { PublicClientApplication, LogLevel, InteractionRequiredAuthError } from "@azure/msal-browser";
import config from './config';

// MSAL Configuration
export const msalConfig = {
  auth: {
    clientId: config.clientId,
    authority: config.authority,
    redirectUri: config.redirectUri,
    postLogoutRedirectUri: config.redirectUri,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    allowNativeBroker: false,
    // Allow silent token refresh with iframes
    allowRedirectInIframe: true,
    loggerOptions: {
      logLevel: LogLevel.Info,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error('[MSAL Error]:', message);
            return;
          case LogLevel.Warning:
            console.warn('[MSAL Warning]:', message);
            return;
          case LogLevel.Info:
            console.info('[MSAL Info]:', message);
            return;
          case LogLevel.Verbose:
            console.debug('[MSAL Debug]:', message);
            return;
          default:
            return;
        }
      }
    }
  }
};

// Scope for login only
export const loginRequest = {
  scopes: ["openid", "profile", "email"]
};

// For API tokens - includes offline_access for refresh token
export const apiTokenRequest = {
  scopes: [config.apiScope],
  forceRefresh: false
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};

let msalInstance = null;

try {
  msalInstance = new PublicClientApplication(msalConfig);
  console.log('✓ MSAL instance created successfully');
} catch (error) {
  console.error('✗ Failed to create MSAL instance:', error);
  throw error;
}

export { msalInstance, InteractionRequiredAuthError };
